(function youtubePlayer(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.videoPlayers = global.NewHomeSource.videoPlayers || {};
  global.NewHomeSource.videoPlayers.youtube = global.NewHomeSource.videoPlayers.youtube || {};

  const youtubeAPI = '//www.youtube.com/iframe_api';
  const playerInformation = {};
  const videoId = 'video-id';
  const elementId = 'element-id';
  const defaultEvents = {
    onEnded: function onEnded() { },
    onPlaying: function onPlaying() { },
    onPaused: function onPaused() { },
    onLoaded: function onLoaded() { },
  };

  let eventsHandler;
  let player;

  /**
  * @private
  * apiFilepath: returns the path where the JavaScript for the requested player can be found.
  */
  function apiFilepath() {
    return global.document.location.protocol + youtubeAPI;
  }

  /**
  * @private
  * loadYoutubeApiScript: loads the Youtube IFrame API needed for the player.
  */
  function loadYoutubeApiScript() {
    if (typeof global.YT === 'object') {
      global.onYouTubeIframeAPIReady();
      return;
    }

    const tag = document.getElementsByTagName('meta')[0];
    const script = document.createElement('script');

    script.type = 'text/javascript';
    script.async = true;
    script.src = apiFilepath();
    tag.parentNode.insertBefore(script, tag);
  }

  /**
   * @private
   * onPlaying: triggers the onPlaying event handler.
   */
  function playingHandler(data) {
    const eventData = data;
    eventData.videoId = playerInformation[videoId];
    eventsHandler.onPlaying(eventData);
  }

  function onReady(event) {
    if (eventsHandler.playOnLoaded) {
      event.target.playVideo();
    }
  }

  function onPlayerStateChange(event) {
    switch (event.data) {
      case 0:
        // Ended.
        eventsHandler.onEnded(event);
        break;
      case 1:
        // Playing.
        playingHandler(event);
        break;
      case 2:
        // Paused.
        eventsHandler.onPaused(event);
        break;
      default:
    }
  }

  /**
  * @private
  * updateVideo: sets a new video in the YouTube player.
  */
  function updateVideo() {
    player.cueVideoById(playerInformation[videoId]);
  }

  /**
  * @constructs YoutubePlayer
  *
  * @param {HTMLVideoElement} video element where the YouTube player is going to be created.
  * @param {string} source id of the video to be displayed.
  * @param {object} config with the extra information needed by the player.
  */
  function Player(video, source, config) {
    playerInformation[videoId] = source;
    playerInformation[elementId] = video;
    eventsHandler = Object.assign({ }, defaultEvents, config);
    loadYoutubeApiScript();
  }

  /**
   * @public
   * createContainer: creates an HTML element needed by the Youtube JavaScript to create the player.
  */
  Player.createContainer = function createContainer() {
    const videoElement = document.createElement('div');
    videoElement.id = 'videoContainer';
    videoElement.style.width = '100%';
    videoElement.style.height = '100%';
    videoElement.innerHTML = '';
    return videoElement;
  };

  /**
  * @public
  * setVideo: changes the source of the video to the given value.
  *
  * @param {HTMLVideoElement} video element where the YouTube player is going to be created.
  * @param {string} source new video ID.
  */
  Player.setVideo = function setVideo(video, source) {
    if (source) {
      playerInformation[videoId] = source;
      playerInformation[elementId] = video;
    }

    if (!player) {
      loadYoutubeApiScript();
      return;
    }

    updateVideo();
  };

  /**
  * @public
  * onYouTubeIframeAPIReady: function invoked by the Youtube IFrame API once all the resources have been loaded.
  */
  global.onYouTubeIframeAPIReady = function onYouTubeIframeAPIReady() {
    if (typeof global.YT !== 'object') {
      return;
    }

    player = new global.YT.Player(playerInformation[elementId], {
      videoId: playerInformation[videoId],
      events: {
        onStateChange: onPlayerStateChange,
        onReady,
      },
    });
  };

  /**
  * @public
  * dispose: destroy the video reference for youtube.
  *
  */
  Player.dispose = function dispose() {
    try {
      if (player) {
        player.destroy();
      }
      // eslint-disable-next-line no-empty
    } catch (error) {

    }
  };

  /**
  * @public
  * pause: pauses the youtube video.
  *
  */
  Player.pause = function pause() {
    try {
      if (player) {
        player.pauseVideo();
      }
      // eslint-disable-next-line no-empty
    } catch (error) {

    }
  };

  /**
  * @public
  * play: plays the youtube video.
  *
  */
  Player.play = function play() {
    try {
      if (player) {
        player.playVideo();
      }
      // eslint-disable-next-line no-empty
    } catch (error) {

    }
  };

  global.NewHomeSource.videoPlayers.youtube.Player = Player;
}(window));

define("youtubeVideoPlayer", function(){});

